import { Box } from "@mui/material";
import { useRef, useState, useEffect } from "react";

/** ---------- ScrollFadeSection: Wrapper für Scroll-Fade-In/Out ---------- */
type ScrollFadeSectionProps = {
  children: React.ReactNode;
};

const ScrollFadeSection: React.FC<ScrollFadeSectionProps> = ({ children }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Sichtbar, wenn ~30% im Viewport
          if (entry.isIntersecting) {
            setInView(true);
          } else {
            setInView(false);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Box
      ref={ref}
      sx={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0px)" : "translateY(40px)",
        transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
      }}
    >
      {children}
    </Box>
  );
};

export default ScrollFadeSection;